import React from "react";

const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

export default function RfmZoomControls({
  zoomLevel = 1,
  min = 0.5,
  max = 1.5,
  step = 0.1,
  onChange, // (newZoom) => void
}) {
  const pct = Math.round(zoomLevel * 100);

  const zoomOut = () => onChange?.(clamp(Number((zoomLevel - step).toFixed(2)), min, max));
  const zoomIn = () => onChange?.(clamp(Number((zoomLevel + step).toFixed(2)), min, max));

  return (
    <div className="rfm-zoom-controls">
      <button
        type="button"
        className="rfm-btn rfm-btn-icon rfm-btn-secondary"
        onClick={zoomOut}
        style={{ width: 26, height: 26, fontSize: "0.8rem" }}
        title="Zoom -"
      >
        <i className="bi bi-dash" />
      </button>

      <span className="rfm-zoom-level">{pct}%</span>

      <button
        type="button"
        className="rfm-btn rfm-btn-icon rfm-btn-secondary"
        onClick={zoomIn}
        style={{ width: 26, height: 26, fontSize: "0.8rem" }}
        title="Zoom +"
      >
        <i className="bi bi-plus" />
      </button>
    </div>
  );
}
